// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__b_3gA","header":"ReportDetails_header__CpBBo","title":"ReportDetails_title__2JYf1","left":"ReportDetails_left__3KSE5"};